'use client'

import { useMutation } from '@tanstack/react-query'
import type { MessageApiResponse } from '@/shared/api/types'
import { toast } from '@/shared/ui/use-toast'
import services from '../services'
import type { CreateGrowthPointBasicsParams } from '../services/create-growth-point-basics'

const getErrorMessage = (message: MessageApiResponse | undefined) => {
  if (!message) return 'Не удалось создать маркетинговую основу'
  if (typeof message === 'string') return message
  return message.map((item) => item.message).join('. ') || 'Не удалось создать маркетинговую основу'
}

const useCreateGrowthPointBasics = (params?: { onSuccess?: () => void }) => {
  return useMutation({
    mutationFn: async ({ projectId }: CreateGrowthPointBasicsParams) => {
      const response = await services.createGrowthPointBasics({ projectId })

      if (!response.ok) {
        throw new Error(getErrorMessage(response.message))
      }

      return response.result
    },
    onSuccess: () => {
      toast({
        title: 'Маркетинговая основа создается',
      })
      params?.onSuccess?.()
    },
    onError: (error: Error) => {
      toast({
        title: 'Ошибка',
        description: error.message || 'Не удалось создать маркетинговую основу',
        variant: 'destructive',
      })
    },
  })
}

export default useCreateGrowthPointBasics
